import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import BaseLayout from '../common/layouts/BaseLayout';
import HeadShared from '../common/HeadShared';
import HeroLanding from '../common/layouts/heroLanding';
import { Container, Margin } from '../common/base';
import { Grid, Col } from '../common/interfaces';
import { AboutWrapper, AboutTeamWrapper } from './Styled';
import ListTeam from './ListTeam';
import teamJson from '../../content/team/team.json';
import advisorList from '../../content/team/advisor';
import dna from '../../content/team/dna';
import BottomCTA from '../landing/components/BottomCTA';

import { withTranslation } from '../common/libs/i18n';

const TitleSection = styled.h2`
  font-size: 48px;
`;

const AboutUs = ({ t }) => (
  <BaseLayout headerType="red">
    <HeadShared title="RupiahToken - About Us" desc="About Rupiah Token" />
    <HeroLanding title={t('about.us.title', 'Our Team')} />
    <div
      css={css`
        background-color: ${({ theme: { colors } }) => colors.light.primary};
      `}
    >
      <Container>
        <AboutWrapper>
          <Margin bottom={80}>
            <Grid justify="center">
              <Col lg={10} md={12}>
                <Grid justify="center" text="center">
                  <Col lg={12} sm={12}>
                    <TitleSection>
                      {t('about.us.we_are_rupiah_token.title', 'We are Rupiah Token Indonesia')}
                    </TitleSection>
                  </Col>
                  <Col lg={7} sm={12}>
                    <Margin bottom={16}>
                      <p>
                        {t(
                          'about.us.we_are_rupiah_token.subtitle',
                          "Rupiah Token Indonesia is Indonesia's leading Blockchain technology company. Just as the internet allowed for borderless and instantaneous movement of information, we believe that Blockchain has the power to improve financial inclusivity and eradicate the difficulty of sending funds between parties."
                        )}
                      </p>
                    </Margin>
                  </Col>
                </Grid>
              </Col>
            </Grid>
          </Margin>
          <Margin bottom={80}>
            <Grid justify="center" text="center">
              <Col lg={10} md={12}>
                <TitleSection>{t('about.us.our_dna.title', 'Our Alma Mater')}</TitleSection>
                <p>
                  {t(
                    'about.us.our_dna.subtitle_1',
                    'We are bringing together the best technical, product, and financial talents in Indonesia.'
                  )}
                  <br />
                  {t(
                    'about.us.our_dna.subtitle_2',
                    'Our team members have previously been shaped into who we are today by the following institutions'
                  )}
                </p>
              </Col>
              <Col lg={10} md={12}>
                <Grid justify="center">
                  {dna.map(item => (
                    <Col
                      lg={3}
                      md={6}
                      sm={12}
                      style={{
                        display: 'inline-block',
                        height: '96px',
                        verticalAlign: 'middle',
                        marginBottom: '48px'
                      }}
                    >
                      <img
                        style={{
                          display: 'block',
                          maxHeight: '100%',
                          height: 'auto',
                          width: 'auto',
                          margin: '0 auto',
                          padding: '12px'
                        }}
                        src={item.image}
                        alt={item.name}
                      />
                    </Col>
                  ))}
                </Grid>
              </Col>
            </Grid>
          </Margin>
          <AboutTeamWrapper>
            <Grid justify="center">
              <Col lg={10} md={12}>
                <Grid>
                  <Col lg={6} sm={12}>
                    <TitleSection>
                      {t('about.us.meet_the_team.title', 'Meet the Team')}
                    </TitleSection>
                  </Col>
                  <Col lg={6} sm={12}>
                    <Margin bottom={80}>
                      <p>
                        {t(
                          'about.us.meet_the_team.subtitle',
                          'We are a strong team of Indonesian professionals who are incredibly passionate about using blockchain to drive positive change in Indonesia.'
                        )}
                      </p>
                    </Margin>
                  </Col>
                </Grid>
                <ListTeam list={teamJson} alignment="right" />
                <Margin top={96}>
                  <Grid>
                    <Col lg={6} sm={12}>
                      <TitleSection>{t('about.us.our_advisor.title', 'Our Advisors')}</TitleSection>
                    </Col>
                    <Col lg={6} sm={12}>
                      <Margin bottom={80}>
                        {/* <p>
                        Our advisors come from notable companies, such as&nbsp;
                        <b>BitTorrent, Citibank, and Asani</b>
                        .&nbsp;
                      </p> */}
                      </Margin>
                    </Col>
                  </Grid>
                </Margin>
                <ListTeam list={advisorList} alignment="left" />
              </Col>
            </Grid>
          </AboutTeamWrapper>
        </AboutWrapper>
      </Container>
    </div>
    <BottomCTA
      topColor="#FFFFFF"
      title={t('about.us.cta_bottom.title', 'Join US')}
      description={t(
        'about.us.cta_bottom.description',
        'If you think this sounds like a challenge for you, let us know as soon as possible'
      )}
      ctaText={t('about.us.cta_bottom.cta_text', 'Apply Here')}
      href="/career"
    />
  </BaseLayout>
);

AboutUs.propTypes = {
  t: PropTypes.func
};

export default withTranslation('common')(AboutUs);
